export default {
    namespaced: true,
    state: {
        obj: {},
        objs: []
    },
    mutations: {
        setObjs(state, pload) {
            state.objs = pload;
        },
        setObj(state, pload) {
            state.obj = pload;
        }
    },
    actions: {
        getData({rootState}, payload) {
            return new Promise((resolve, reject) => {
                let url = `${rootState.config.apiHost}pembagian-koordinator?size=${payload.size}&date=${payload.date}&coordinator=${payload.coordinator}&previous_coordinator=${payload.previous_coordinator}&next_coordinator=${payload.next_coordinator}`;
                this._vm.$axios.get(url,{headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response.data.data)
                    }, error => {
                        reject(error)
                    });
            });
        },
        store({rootState}, payload) {
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + "pembagian-koordinator";
                this._vm.$axios.post(url, JSON.stringify(payload), {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    });
            });
        }
    }
}